import waitUntil from 'async-wait-until';
import { closest, hasClass, addClass, removeClass, createEvent, removeNode } from '@utils/domUtils';

export default class JobAdImageSelector {
  static selectorString() {
    return '.JobAdImageSelector';
  }

  setJobAdImages(images) {
    this.jobAdImageList.innerHTML = '';
    images.forEach(image => {
      const preview = this.jobAdImageTemplate.cloneNode(true);
      preview.setAttribute('data-id', image.id);
      preview.setAttribute('data-image', image.src);
      preview.querySelector(
        '[data-prop="jobAdImagePreview"]',
      ).style.backgroundImage = `url(${image.preview})`;
      preview.addEventListener('click', this.toggleImage.bind(this));
      this.jobAdImageList.appendChild(preview);
    });

    this.renderPreview();
  }

  async render(node, props) {
    this.fileUpload = node.querySelector('.FileUpload');
    this.jobAdEditor = closest(node, '.JobAdEditor');
    this.jobEditSidebar = closest(node, '.JobEditSidebar');
    this.jobProfileImage = node.querySelector('[data-prop="jobProfileImage"]');

    this.jobAdImageList = node.querySelector('[data-prop="jobAdImageList"]');
    this.jobAdImageWrapper = node.querySelector('.default-job-ad-image-wrapper');
    this.jobAdImageTemplate = node.querySelector('.default-job-ad-image-template');
    removeNode(this.jobAdImageTemplate);
    removeClass(this.jobAdImageTemplate, 'default-job-ad-image-template');
    removeClass(this.jobAdImageTemplate, 'hide');

    await waitUntil(() => this.fileUpload.component);
    await waitUntil(() => this.jobAdEditor.component);
    await waitUntil(() => this.jobEditSidebar.component);

    [...node.querySelectorAll('.default-job-ad-image')].forEach(element => {
      element.addEventListener('click', this.toggleImage.bind(this));
    });

    this.fileUpload.addEventListener('fileUploadComplete', this.fileUploaded.bind(this));
    this.fileUpload.addEventListener('fileRemoved', this.renderPreview.bind(this));
    this.renderPreview();
  }

  deselectJobProfileImage() {
    [...this.node.querySelectorAll('.default-job-ad-image')].forEach(element => {
      removeClass(element, 'selected');
    });

    this.jobProfileImage.value = null;
  }

  toggleImage(event) {
    if (hasClass(event.currentTarget, 'selected')) {
      this.deselectImage(event.currentTarget);
    } else {
      this.selectImage(event.currentTarget);
    }
  }

  deselectImage(image) {
    this.deselectJobProfileImage();
    removeClass(image, 'selected');
    this.fileUpload.component.removeUploadedImages();
    this.renderPreview();

    this.jobEditSidebar.dispatchEvent(createEvent('contentChanged'));
  }

  selectImage(image) {
    this.deselectJobProfileImage();
    addClass(image, 'selected');
    this.jobProfileImage.value = image.getAttribute('data-id');
    this.fileUpload.component.removeUploadedImages();
    this.renderPreview();

    this.jobEditSidebar.dispatchEvent(createEvent('contentChanged'));
  }

  fileUploaded() {
    this.deselectJobProfileImage();
    this.renderPreview();
  }

  renderPreview() {
    if ([...this.node.querySelectorAll('.default-job-ad-image')].length === 0) {
      addClass(this.jobAdImageWrapper, 'hide');
      this.jobProfileImage.value = null;
    } else {
      removeClass(this.jobAdImageWrapper, 'hide');
    }

    const files = this.fileUpload.component.getUploadedFiles();

    // TODO: does not work if file upload has already a file!
    // i.e. try uploading job ad image, save job. edit job again, upload new file... -> newest file does not get selected..
    // NOTE: prefering custom upload if provided
    if (files && files[0] && files[0].dataURL) {
      // just double ensuring that default profile image selection gets cleared...
      this.deselectJobProfileImage();
      this.jobAdEditor.component.setJobAdImage(files[0].dataURL);
      return;
    }

    // otherwise: rendering selected job profile image, if provided
    if (!isNaN(this.jobProfileImage.value)) {
      const image = this.node.querySelector(
        `.default-job-ad-image[data-id="${this.jobProfileImage.value}"]`,
      );

      if (image) {
        const imageUrl = image.getAttribute('data-image');

        if (imageUrl && imageUrl.length > 0) {
          this.jobAdEditor.component.setJobAdImage(imageUrl);
          return;
        }
      }
    }

    this.jobAdEditor.component.setJobAdImage(null);
  }
}
